export function numberToIntervalCount(count: number) {
  let result = count;
  const countString = count.toString();
  const twoLastNumber = countString.slice(countString.length - 2);
  const countFromToLastNumber = Number(twoLastNumber);

  if (count <= 29) {
    result = countFromToLastNumber;
  } else {
    const lastNumber = twoLastNumber.slice(1);
    result = Number(`2${lastNumber}`);
  }

  return result;
}
